import React from 'react';
import cookie from 'react-cookies';
import FormData from 'form-data';
import moment from 'moment';
import { URL_PATH, UPPER_CASE_BREAD_CRUMB } from '../constants';


// export const getImage = (publicUrl, options) => {
//     let url = '';
//     url = ENV_CONFIG.CLOUDINARY_URLS.CLOUD_ACCOUNT_URL;
//
//     //Add default options for optimization
//     url += 'q_80,fl_lossy,f_auto';
//
//     // Adding options with request url eg: height, width
//     if (options && options.width) {
//         url += ',w_' + options.width;
//     }
//     if (options && options.aspectRatio) {
//         url += ',ar_' + options.aspectRatio;
//     }
//     if (options && options.height) {
//         url += ',h_' + options.height;
//     }
//
//     return url + '/' + publicUrl;
// };


export const getYoutubePosterImage = (youtubeId) => {
   let youtubeBaseURL = 'https://img.youtube.com/vi/',
       youtubePoster = '/mqdefault.jpg';


   return youtubeBaseURL + youtubeId + youtubePoster;
};


export const createUrl = (url, urlparams, urlquery) => {
   if(urlparams){
       const {...params} = urlparams;
       params && Object.keys(params).forEach((key) => {
           url = url.replace(`/:${key}`, `/${params[key]}`);
       });
   }
   if(urlquery){
       const {...query} = urlquery;
       query && typeof query === "object" && Object.keys(query).forEach((key, index) => {
           url += `${(index) ? '&' : '?'}${key}=${query[key]}`
       });
   }
   return url;
};


export const getLang = () => {
 return cookie.load('selectedLanguage') ? cookie.load('selectedLanguage'): 'en';
};


export const getLayeredIcon=(iconName)=>{
   switch(iconName){
       
       case 'icon-checkboxes-01' :
           return (
               <i className="icon-checkboxes-01"><span className="path1"></span><span className="path2"></span></i>
           );
      
       case 'icon-radio_checked' :
           return (
               <i className="icon-radio_checked">
                   <span className="path1"></span><span className="path2"></span>
               </i>
           );


       default:
           return <i className={iconName} />
   }
};


export const getRouting=(page, data, nodeId,productFilter="")=>{
   if(page && page.indexOf('/')===0){
       return page;
   }
   let pageUrl = page && page.toLowerCase().trim().split(' ').join('-'), currentUrl;
   data = data && data.toLowerCase().replace('\’', '').trim().split(' ').join('-');
   if(__CLIENT__){
       currentUrl = window.location.pathname.split('/')[2];
       if (currentUrl==undefined) currentUrl = window.location.pathname.split('/')[1];
   }
   switch(pageUrl){
       case 'contact-us':
           return createUrl(URL_PATH.CONTACT_US)
       case 'statutory-information':
           if(data.match(/nav/)){
               return createUrl(URL_PATH.NAV_AND_DIVIDEND)
           }
           if(currentUrl=="") {
               return createUrl(URL_PATH.STATUTORY_INFORMATION, {
                   pageType: data,
                   informationType: data
               })
           }
           else {
               data = data.replace('/','-');
               return createUrl(URL_PATH.STATUTORY_INFORMATION,{ informationType: data })
           }
       case 'information':
           if(data.match(/nav/)){
               return createUrl(URL_PATH.NAV_AND_DIVIDEND)
           }
           if(currentUrl=="") {
               return createUrl(URL_PATH.INFORMATION, {
                   pageType: data,
                   informationType: data,
                   informationId: nodeId
               })
           }
           else {
               data = data.replace('/','-');
               data=data.replace(/,|\(|\)/g, '')
               return createUrl(URL_PATH.INFORMATION,{ informationType: data, informationId: nodeId})
           }
       case 'careers-detail':
           return createUrl(URL_PATH.AVAILABLE_POSITION,{positionId:nodeId});
       case 'careers':
           return createUrl(URL_PATH.CAREERS);
       case 'videos':
           return createUrl(URL_PATH.VIDEOS);
       case 'podcast':
           return createUrl(URL_PATH.PODCASTS);
       case 'product-schemes':
           return createUrl(URL_PATH.OUR_PRODUCTS,{[productFilter]: data},{});
       case 'our-products':
           return createUrl(URL_PATH.OUR_PRODUCTS);
       case 'cost-of-child-education':
           return createUrl(URL_PATH.CHILD_EDUCATION_CALCULATOR);
       case 'present-value':
           return createUrl(URL_PATH.PRESENT_VALUE);
       case 'sip-calculator':
           return createUrl(URL_PATH.SIP);
       case 'goal-sip':
           return createUrl(URL_PATH.GOAL_SIP);
       case 'top-up-sip':
           return createUrl(URL_PATH.TOP_UP_SIP);
       case 'retirement-corpus':
           return createUrl(URL_PATH.RETIREMENT_CALCULATOR);
       case 'impact-of-inflation':
           return createUrl(URL_PATH.IMPACT_OF_INFLATION);
       case 'glossary':
           return createUrl(URL_PATH.GLOSSARY);
       case 'distributor-register':
           return createUrl(URL_PATH.REGISTRATION);
       case 'distributor-empanel':
           return createUrl(URL_PATH.EMPANLMENT);
       case 'calculators':
           return createUrl(URL_PATH.CALCULATORS);
       case 'resources':
           return createUrl(URL_PATH.RESOURCES);
       case 'article':
           return createUrl(URL_PATH.ARTICLE_DETAIL, { pageType: productFilter, articleType: data, articleId: nodeId});
       case 'child-education':
           return createUrl(URL_PATH.CHILD_EDUCATION);
       case 'beginner':
           return createUrl(URL_PATH.BEGINNER);
       case 'intermediate':
           return createUrl(URL_PATH.INTERMEDIATE);
       case 'advanced':
           return createUrl(URL_PATH.ADVANCED);
       case 'learn':
           return createUrl(URL_PATH.LEARN);
       case 'product':
           return createUrl(URL_PATH.PRODUCT_SCHEME, { pageType: currentUrl, productType: data, productId: nodeId});
       case 'distributor-desk':
           return createUrl(URL_PATH.DISTRIBUTOR_DESK);
       case 'investor-desk':
           return createUrl(URL_PATH.INVESTOR_DESK);
       case 'about-us':
           return createUrl(URL_PATH.ABOUT_US);
       case 'hdfc-amc':
           return createUrl(URL_PATH.HDFC_AMC);
       case 'global-search':
           return createUrl(URL_PATH.GLOBAL_SEARCH);
       case 'contact-us':
           return createUrl(URL_PATH.CONTACT_US);
       case 'aboutus':
           return createUrl(URL_PATH.ABOUT_US);
       case 'statutory-disclosure':
           return createUrl(URL_PATH.DISCLOSURE);
       case 'apply-for-arn-or-renew-your-arn':
           return createUrl(URL_PATH.REG_ARN);
       case 'gold-cash-component':
           return createUrl(URL_PATH.GOLD_CASH_COMPONENT);
       case 'silver-cash-component':
           return createUrl(URL_PATH.SILVER_CASH_COMPONENT);
       case 'calculate-creation-component':
           return createUrl(URL_PATH.CALCULATE_CREATION_COMPONENT,
             { creationType: data, productName: nodeId });
       case 'rebalancing':
           return createUrl(URL_PATH.REBALANCING_COMPONENT,
               { creationType: data, productName: nodeId });
       default:
           if (pageUrl && pageUrl.match("quiz")) {
               return createUrl(URL_PATH.QUIZ);
           }
           return '/';
   }
};


export const autoCapital = value => {
   if(value!=undefined){
       if(typeof value === 'string'){
           // if(value.toLowerCase() === 'mba')
           //     return value.toUpperCase();
           let newValues = [];
           value.split(' ').forEach((e,i)=>{
               let lowerCase = e.toLowerCase();
               let upperCase = e.toUpperCase();
               if(UPPER_CASE_BREAD_CRUMB.includes(upperCase)) {
                   newValues[i] = upperCase;
               } else {
                   newValues[i] = lowerCase.charAt(0).toUpperCase() + lowerCase.substr(1);
               }
           });
           return newValues.join(' ');
       }else{
           return value;
       }
   }


};


export const formDataGenerator = (data) => {
   let formDataValue = new FormData();
   if(typeof data === 'object' && data !== null){
       let keys = Object.keys(data);
       keys.map((key)=> {
           formDataValue.append(key, data[key]);
       });
       return formDataValue;
   }
   return {};
};


export const removeClass = (element,...classNames)=> {
   classNames.forEach(className=>{
       element && element.classList!=undefined ? element.classList.contains(className) && element.classList.remove(className)
           : console.log('Element not Found! Cannot remove '+className+' class');
   });
};


export const addClass = (element,...classNames)=> {
   classNames.forEach(className=>{
       element ? !element.classList.contains(className) && element.classList.add(className)
           : console.log('Element not Found! Cannot add '+className+' class');
   });
};


export const digitToRupeeNotation=(value)=>{
   if(!isNaN(value)){
       value = typeof value === 'string' ? +value : value;
       value = value.toString();
       let lastThree = value.substring(value.length - 3);
       let otherNumbers = value.substring(0, value.length - 3);
       if (otherNumbers != '')
           lastThree = ',' + lastThree;
       let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
       return res;
   }
   else{
       return NaN;
   }
};


export function isNotDecimalNumber(value) {
   return isNaN(value) ? true: (value+'').indexOf('.')!=-1;
}


export function getValuesInSpan(values,className){
   let props = className ? {className:className} : {}
   return values.map((value,i)=>(<span key={i} {...props}>{value}</span>))
}


export function getValuesInContainer(container,values,className){
   let props = className ? {className:className} : {}
   //return values.map((value,i)=>(<container key={i} {...props}>{value}</container>))
   return values.map((value,i)=>(React.createElement(container, {...props,key:i},value)))
}


export const itemInArray=(arr,value)=>{
   let index = arr && arr.indexOf(value);
   if(index === -1) {
       return arr.push(value)
   }
   else {
       return arr.splice(index,1)
   }
};


export const getDropdownData=(obj,additional)=>{
   if(obj) {
       let values = Object.keys(obj),returnValue;
       returnValue = values.map((item, index) => {
           return {name: obj[item], value: item}
       });
       additional && returnValue.unshift(additional);
       return returnValue;
   }
}


export const typeOfCustom=(value)=>{
   return Object.prototype.toString.call(value).split(' ')[1].split(']')[0].toLowerCase();
}


export const noResultFound=(objOrArray)=>{
   if(objOrArray){
       if(typeOfCustom(objOrArray)==='array'){
           return objOrArray.length===0;
       }else if(typeOfCustom(objOrArray)==='object'){
           return Object.keys(objOrArray).indexOf('noResult')!==-1;
       }
   }else{
       return true; //if value is null or undefined; no results found.
   }
}


export const hideElementAfterDelay=(element,delay=100)=>{
   if(element){
       setTimeout(()=>{
           element.style.display = 'none';
       },delay);
   }else{
       //console.log('cannot hide element after delay');
   }
}




export const scrollToContentNavDiv = (element) => {
   let scrollToElement = require('scroll-to-element');
   scrollToElement(element, {
       offset: -(document.getElementsByClassName('new-website')[0].clientHeight + document.querySelectorAll('header')[0].clientHeight),
       ease: 'linear',
       duration: 1000,
       align: top


   });
}


export const scrollToContent=(element)=>{
   let scrollToElement = require('scroll-to-element');
   scrollToElement(element, {
       offset:-(document.getElementsByClassName('secondary-nav')[0].clientHeight+document.querySelectorAll('header')[0].clientHeight),
       ease: 'linear',
       duration: 1000,
       align: top


   });
}


export const scrollContent = () => {
   // console.log("scrollContent");
   if(__CLIENT__) {
       if (window.innerWidth < 1170 && document.getElementsByTagName('input')[0] && document.activeElement.tagName.toLocaleLowerCase() == "input") {
           // console.log("condton");
           window.scrollTo(100, 100);
       }
   }
}


export const getFileExtension=(filename)=>{
   if(filename)
       return filename.substring(filename.lastIndexOf('.')+1, filename.length);
};


export const getIconForFile=(filename)=>{
   let extension = getFileExtension(filename) && getFileExtension(filename).toLowerCase();
   switch (extension){
       case 'pdf':
           return <i className='icon-download-pdf'></i>
       case 'xls':
           return <i className='icon-excel'></i>
       case 'xlsx':
           return <i className='icon-excel'></i>
       case 'ppt':
           return <i className='icon-ppt'></i>
       case 'doc':
       case 'docx':
           return <i className='icon-doc'></i>
       default:
           break;
   }
};


function get_host(url){
   var match = url.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
   if(match){
       return `${match[1]}//${match[2]}`;
   }
   // return url.replace(/^((\w+:)?\/\/[^\/]+\/?).*$/,'$1');
}
export const getLocationOrigin=(url)=>{
   if(isSameOrigin(url)){
       if(/https:\/\/dev.hdfcfund.com/.test(url)){
           return (url.replace('https://dev.hdfcfund.com', ''))
       }
       else if(/https:\/\/qa.hdfcfund.com/.test(url)){
           return (url.replace('https://qa.hdfcfund.com', ''))
       }
       else if(/https:\/\/uat.hdfcfund.com/.test(url)){
           return (url.replace('https://uat.hdfcfund.com', ''))
       }
       else if (/https:\/\/beta.hdfcfund.com/.test(url)){
           return (url.replace('https://beta.hdfcfund.com', ''))
       }
       else if (/https:\/\/web.hdfcfund.com/.test(url)){
           return (url.replace('https://web.hdfcfund.com', ''))
       }
       else if (/https:\/\/www.hdfcfund.com/.test(url)){
           return (url.replace('https://www.hdfcfund.com', ''))
       }
       /*Need to Prod Configuration*/


   }
   return url;
};


export const isExternalUrl = (url) => {
   if(url.indexOf('https:') !== -1){
       return true;
   }
   return false;
}


export const isSameOrigin=(url)=>{
   if(url!=null && typeof location !='undefined' && typeof location.origin != 'undefined' &&
       (("https://www.hdfcfund.com"==get_host(url)) || ("https://beta.hdfcfund.com"==get_host(url)) ||
       ("https://uat.hdfcfund.com"==get_host(url)) || ("https://qa.hdfcfund.com"==get_host(url)) ||
       ("https://dev.hdfcfund.com"==get_host(url)) || ("https://web.hdfcfund.com"==get_host(url)))) {
       return true;
   }
   return false


};


export const cleanURL = (url) => {
   if(url.slice(0, 2) === '//'){
       return 'https://' + url.slice(2);
   }
   return url;
}


export const stripHTML = (html) => html && html.replace(/(<([^>]+)>)/gi, "");


export const convertHTMLEntities = (str) => {
   var output = str && str
   .replace('&nbsp;', ' ').replace('&#160;', ' ')
   .replace('&lt;', '<').replace('&#60;', '<')
   .replace('&gt;', '>').replace('&#62;', '>')
   .replace('&amp;', '&').replace('&#38;', '&')
   .replace('&quot;', '"').replace('&#34;', '"')
   .replace('&apos;', "'").replace('&#39;', "'")
   .replace('&cent;', '¢').replace('&#162;', '¢')
   .replace('&pound;', '£').replace('&#163;', '£')
   .replace('&yen;', '¥').replace('&#165;', '¥')
   .replace('&euro;', '€').replace('&#8364;', '€')
   .replace('&copy;', '©').replace('&#169;', '©')
   .replace('&reg;', '®').replace('&#174;', '®')
   .replace(/(\r\n\t|\n|\r|\t)/gm, " ")
   .replace(/(&nbsp;)/g, " ")
   return output;
}


export const faqGenerator = (data, ignoreTitle = false) => {
   let output = data;
   if(ignoreTitle){
       output = [];
       data.forEach(d => {
           const qas = d.body.split('class="ques-gfaq">');
           qas.forEach((qa, index) => {
               const qaSplitIndex = qa.indexOf('</strong>');
               const question = stripHTML(qa.substring(0, qaSplitIndex));
               const answer = stripHTML(qa.substring(qaSplitIndex+9) + `${index === qas.length-1 ? '' : '>'}`);
               if(question && answer) {
                   output.push({
                       title: question,
                       body: answer,
                   });
               }
           })
       });
   }
   return output;
}
export const getCurrentYear = () => moment().format('YYYY');


export const lazyImage = () => {
   if ("IntersectionObserver" in window) {
   const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          if (entry.target.hasAttribute("data-src")) {
            entry.target.setAttribute(
              "src",
              entry.target.getAttribute("data-src")
            );
            observer.unobserve(entry.target);
          }
        }
      });
    });
    document.querySelectorAll(".lazy-image").forEach((gameImg) => {
      if (gameImg.getAttribute("is-observed") != "true" && gameImg.getAttribute("data-src") != null)
      {
        gameImg.setAttribute("is-observed", "true")
        observer.observe(gameImg);  
      }
    });
  } else {
    var imgList = document.querySelectorAll(".lazy-image");
    Array.prototype.forEach.call(imgList, function (image) {
      image.setAttribute("src", image.getAttribute("data-src"));
    });
  }
};
export const checkIframeContent = () => {
    let isIframeContent = true;
    if (__CLIENT__) {
      const referrer = document.referrer;
      if(referrer == 'https://distributor.hdfcfund.com/'){
        isIframeContent =  false;
      }
    }
    return isIframeContent;
};
export const convertAmountToWords = (num) => {
   var a = ['','one ','two ','three ','four ', 'five ','six ','seven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];

   var b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];

   if ((num = num.toString()).length > 9) return 'overflow';
   var n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
   if (!n) return; var str = '';
   str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
   str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
   str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
   str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
   str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'Rupees Only ' : 'Rupees Only ';
   return autoCapital(str);
}
export const checkTickerUrls = () => {
   let tickerUrl = true;
   if (__CLIENT__) {
       const isLearnersCorner = window.location.pathname.includes("learners-corner");
       const isSipSaheli = window.location.pathname.includes("sipsaheli");
       const isLearn = window.location.pathname.includes("learn");
       const isShorts = window.location.pathname.includes("mutual-fund-shorts");
       if(isLearnersCorner || isLearn || isSipSaheli || isShorts){
           tickerUrl = false;
       }
   }
   return tickerUrl;
};
export const generateBreadcrumbs = (url) => {
    const baseUrl = "https://www.hdfcfund.com";
    const pathSegments = url.replace(baseUrl, "").split("/").filter(Boolean);
  
    return pathSegments.map((segment, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": segment.replace(/-/g, " "), // Replaces hyphens with spaces for readability
      "item": `${baseUrl}/${pathSegments.slice(0, index + 1).join("/")}`
    }));
};
